import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center px-6 text-center">
      <div>
        <p className="text-sm font-medium tracking-wider text-fg-subtle uppercase">404</p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight">Страница не найдена</h1>
        <p className="mt-2 text-sm text-fg-muted">Ссылка устарела или мы ещё не добрались до этой части.</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-brand-accent px-4 py-2 text-sm font-medium text-white hover:bg-brand-action"
        >
          На главную
        </Link>
      </div>
    </div>
  );
}
